WW.bookcourses = function ($) {
    const modalDialog = $('#modal-dialog');

    modalDialog.on('click', '.js-book-courses-submit', function() {
        var theResult = true; // continue submiting if no error

        var name=$('.js-validate-name').val();
        var company=$('.js-validate-company').val();
        var email=$('.js-validate-email').val();
        var phoneNumber= $('.js-validate-phone').val();
        var course=$('.js-validate-course').val();
        var message=$('.js-validate-message').val();
        
        var threeLettersPattern = /\w{3}/;
        
        if ( threeLettersPattern.test (name) ) {
            $('.js-validate-name-error').hide();
        } 
        else {
            $('.js-validate-name-error').show();
            theResult=false;
        }

        if ( threeLettersPattern.test (company) ) {
            $('.js-validate-company-error').hide();
        } 
        else {
            $('.js-validate-company-error').show();
//            $('.js-validate-company-error').html('company='+company);
            theResult=false;
        }
        
        var emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//        var emailPattern =/^([\w\!\#$\%\&\'\*\+\-\/\=\?\^\`{\|\}\~]+\.)*[\w\!\#$\%\&\'\*\+\-\/\=\?\^\`{\|\}\~]+@((((([a-z0-9]{1}[a-z0-9\-]{0,62}[a-z0-9]{1})|[a-z])\.)+[a-z]{2,6})|(\d{1,3}\.){3}\d{1,3}(\:\d{1,5})?)$'/i;
        if  ( emailPattern.test(email) ) {
            $('.js-validate-email-error').hide();
        }
        else {
            $('.js-validate-email-error').show();
//            $('.js-validate-email-error').html( 'email='+email );
            theResult=false;
        }
        
        
        var phonePattern = /^[0-9\-\+\(\)\s]+$/;
        if ( phonePattern.test( phoneNumber ) ) {
            $('.js-validate-phone-error').hide();
        }
        else {
            $('.js-validate-phone-error').show();
            theResult=false;
        }
        
        if ( course !== null && course.length > 0 ) {
            $('.js-validate-course-error').hide();
        }
        else {
            $('.js-validate-course-error').show();
            theResult=false;
        }

        if ( threeLettersPattern.test (message) ) {
            $('.js-validate-message-error').hide();
        } 
        else {
            $('.js-validate-message-error').show();
            theResult=false;
        }
        
        return theResult;
    });

    return this;
};


